import React, { useEffect, useState } from 'react'
import {Container } from 'react-bootstrap'
import { Button, Card, Spin, MenuProps, Dropdown, Space, message, Row, Col} from 'antd'
import withAuth from '../components/authHOC'
import { TfiReload } from 'react-icons/tfi'
import { getAnalytics } from '../actions/analyticsActions'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { IBranch } from '../components/UsersTable'
import { selectUserDetails } from '../features/auth/authSlice'
import { DatePicker } from 'antd'
import moment, { Moment } from 'moment'
import dayjs, { Dayjs } from 'dayjs'
import { GrTransaction } from "react-icons/gr"
import { FaMoneyBillTransfer} from "react-icons/fa6"
import { IoWallet } from 'react-icons/io5'
import { IoIosPeople, IoMdArrowDropright } from 'react-icons/io'
import MonthlyCharts from '../components/MothlyTotalCharts'
import LoanStatusChart from '../components/LoanPieCharts'
import { IInstitution } from '../factory/interfaces'
import { DownOutlined } from '@ant-design/icons'

const { RangePicker } = DatePicker

const DashboardPage = () => {
  const analytics = useSelector((state: any) => state.analytics)
  const dispatch = useDispatch()
  const user_details = useSelector(selectUserDetails)
  const [institution, setInstitution]= useState<IInstitution>()
  const [currency, setCurrency] = useState< string | undefined>()
  const [branch, setSelectedBranch] = useState<string>()
  const metadata = useSelector((state: any) => state.metadata)
  const [branches, setBranches]= useState<IBranch[]>()
  const [branchName, setBranchName] = useState<string | undefined>()
  const currentYear = new Date().getFullYear()
  const [selectedYear, setSelectedYear] = useState<any>(currentYear)

  const [dateRange, setDateRange]= useState<string[]>([`${currentYear}-01-01`, `${currentYear}-12-31`])
      // Convert string array to moment array
  const momentArray: Moment[] = dateRange.map(date => moment(date))
  type EventValue<T> = T | null
  // Convert moment array to Dayjs array
  const dayjsArray: Dayjs[] = momentArray.map(date => dayjs(date.toDate()));
    const valueArray: [EventValue<Dayjs>, EventValue<Dayjs>] = [
    dayjsArray[0] || undefined,
    dayjsArray[1] || undefined,
  ];

  //merge branches with user branches

  const monthlyTotals = analytics && analytics.data.loans ? analytics.data.loans.monthly : [];

useEffect(() => {
    if (metadata?.data?.success) {
      setInstitution(metadata.data.meta_data.institution)
      setCurrency(metadata.data.meta_data?.configs?.currency)
      setBranches(metadata.data.meta_data.branches)
    }
  }, [metadata])


useEffect(()=>{
  if(branch){
  dispatch(getAnalytics(dateRange[0], dateRange[1], branch, selectedYear) as any)
  }
}, [dispatch, dateRange, branch, selectedYear])


const items: MenuProps['items'] = branches?.map(branch => ({
    label: branch.name.toUpperCase(),
    key: branch._id,
  }))

 const onClick: MenuProps['onClick'] = ({ key }) => {
    const selected = branches?.find(branch => branch._id === key)
    if (selected) {
      setBranchName(selected.name)
      setSelectedBranch(key)
      message.info(`Selected branch: ${selected.name}`)
    }
  }

  const handleYearChange = (year: number) => {
    setSelectedYear(year)
  }

  return (
    <Container fluid>
      <Row className=' justify-content-between align-items-center py-0 g-0'>
            <Col className='text-start d-flex justify-content-start'>
              <h4 className='text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16, marginRight: 20}}> <IoMdArrowDropright />Overview</h4>
               <Dropdown menu={{ items, onClick }}>
                <a onClick={(e) => e.preventDefault()}>
                  <Space className='text-uppercase'>
                    {branchName ? branchName: 'Select Branch'}
                    <DownOutlined />
                  </Space>
                </a>
              </Dropdown>
           </Col>
        {(analytics.data.success && metadata.data.success && branch) &&


         <Col className='d-flex justify-content-end text-end py-2 align-items-center'>
         <Button type='link' className='btn-info rounded-0 text-uppercase fw-bold' style={{background: '#6cb26d', color: '#000'}}>
          Balance on account: {analytics.data.cashbook_balance.toLocaleString()} /=
         </Button>
         <RangePicker onChange={(date, dateString)=> setDateRange(dateString)} className='rounded-0 mx-2'
             value={valueArray}
             />
         <Button onClick={()=>dispatch(getAnalytics(dateRange[0], dateRange[1], branch, selectedYear) as any)} className='rounded-0' type="dashed"> <TfiReload/> <span className='mx-1'>Reload</span></Button>
         </Col>
          }
        </Row>
        {(analytics.data.success && metadata.data.success && branch) ?
        <>
        <Row gutter={[16, 16]} style={{marginTop: 16, marginBottom: 16}}>
        <Col xs={24} sm={12} lg={6}>
        <Card bordered={true} style={{background:'#0062ff7b', height: '100%'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
         <div style={{flexShrink: 0}}>
            <FaMoneyBillTransfer size={50} color='#0062ff' style={{ background: '#ffffff', padding: '8px', borderRadius: '50px' }} />
          </div>
        <div style={{flex: 1}}>
          <h4 style={{margin: 0, fontSize: '14px'}}>Loans Issued</h4>
          <h3 style={{margin: 0, fontSize: '20px', fontWeight: 'bold'}}>{currency} {analytics.data.loans.total_loans_issued.toLocaleString()}</h3>
        </div>
        </div>
        </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
        <Card bordered={true} style={{background:'#fe5f3788', height: '100%'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <div style={{flexShrink: 0}}>
            <GrTransaction size={50} color='#fe5f37' style={{ background: '#ffffff', padding: '8px', borderRadius: '50%' }} />
          </div>
        <div style={{flex: 1}}>
          <h4 style={{margin: 0, fontSize: '14px'}}>Expenses</h4>
          <h3 style={{margin: 0, fontSize: '20px', fontWeight: 'bold'}}>{currency} {analytics.data.transactions.total_expenses.toLocaleString()}</h3>
        </div>
        </div>
        </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
        <Card bordered={true} style={{background:'#33b55a7d', height: '100%'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <div style={{flexShrink: 0}}>
            <IoWallet size={50} color='#33b55a' style={{ background: '#ffffff', padding: '8px', borderRadius: '50%' }} />
          </div>
        <div style={{flex: 1}}>
         <h4 style={{margin: 0, fontSize: '14px'}}>Total Savings</h4>
          <h3 style={{margin: 0, fontSize: '20px', fontWeight: 'bold'}}> {currency} {analytics.data.savings.total_savings.toLocaleString()}</h3>
        </div>
        </div>
        </Card>
        </Col>

        <Col xs={24} sm={12} lg={6}>
        <Card bordered={true} style={{background:'#9fd8f3', height: '100%'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <div style={{flexShrink: 0}}>
            <IoIosPeople size={50} color='#188abe' style={{ background: '#ffffff', padding: '8px', borderRadius: '50%' }}  />
          </div>
        <div style={{flex: 1}}>
          <h4 style={{margin: 0, fontSize: '14px'}}>Clients</h4>
          <h3 style={{margin: 0, fontSize: '20px', fontWeight: 'bold'}}> PP {analytics.data.clients.total.toLocaleString()}</h3>
        </div>
        </div>
        </Card>
        </Col>
        </Row>

        {
          analytics.data.loans.monthly &&
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={16}>
          <MonthlyCharts monthlyTotals={monthlyTotals} selectedYear={selectedYear} onYearChange={handleYearChange}></MonthlyCharts>
          </Col>
          <Col xs={24} lg={8}>
          <LoanStatusChart by_status={analytics.data.loans.by_status}></LoanStatusChart>
          </Col>
        </Row>
        }
        </>
        :
         branch ?

        <Spin style={{paddingTop: 100}} tip="Analytics loading..." size="large">
        <div className="content" />
        </Spin>
        : 
        <>
        </>
        }
        

    </Container>
  )
}

export default withAuth (DashboardPage, ['admin'])
